export function handleLinkClickToCloseModal(modalId) {
    const modalContainer = document.getElementById(modalId);
    if (modalContainer) {
        modalContainer.addEventListener("click", (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            if (e.target.classList.contains("dropdown__trigger")) return;
            MicroModal.close(modalId);
        });
    }
}
